import { createContext } from 'react'

import { TOverrideType } from 'utility-tools/module/types'
import { IOrderDetailsApiDto } from 'nexchange-service/module/order'

interface IOrderDetailsApiDtoProviderState extends IOrderDetailsApiDto {}

const OrderDetailsApiDtoProvider = createContext<IOrderDetailsApiDtoProviderState>(null)

export type { IOrderDetailsApiDtoProviderState }
export { OrderDetailsApiDtoProvider }
